<template>
  <div class="space-y-8">
    <SectionHeader :title="__('Perks')">
      <template #icon>
        <Icon class="text-3xl text-primary" name="loyalty" is-filled />
      </template>
      <template v-if="canEdit" #button>
        <div class="ml-auto">
          <Button
            class="flex items-center gap-1.5"
            variant="ghost"
            @click="
              isEditing ? handleCancelButtonClick() : handleEditButtonClick()
            "
          >
            <Icon class="text-lg" :name="isEditing ? 'close' : 'edit'" />
            <span>{{ isEditing ? __('Cancel') : __('Edit') }}</span>
          </Button>
        </div>
      </template>
    </SectionHeader>

    <PerksEdit
      v-if="isEditing"
      :data="data"
      :options="options"
      :error-message="errorMessage"
      @cancel="handleCancelButtonClick"
      @save="handleSaveButtonClick"
    />
    <PerksView v-else :data="data" :fields="fields" />
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { SectionHeader } from '@/pages/components/section-header';
  import { PerksEdit } from './components/perks-edit';
  import { PerksView } from './components/perks-view';

  const props = defineProps({
    data: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    fields: {
      type: Object,
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  });

  const emits = defineEmits(['update-is-editing', 'update-percentages', 'update-data']);

  const data = ref(JSON.parse(JSON.stringify(props.data)));
  const fields = ref(JSON.parse(JSON.stringify(props.fields)));

  function handleEditButtonClick() {
    emits('update-is-editing', true);
  }

  function handleCancelButtonClick() {
    emits('update-is-editing', false);
  }

  function handleSaveButtonClick(value) {
    data.value = value.data;
    fields.value = value.fields;

    emits('update-data', data.value);
    emits('update-is-editing', false);
    emits('update-percentages', {
      sectionPercentage: value.sectionPercentage,
      resumePercentage: value.resumePercentage
    });
  }
</script>
